import React from 'react'
import styled from 'styled-components';
import CupoySrefView from '../commons/router/CupoySrefView';
import Colors from '../../stylecomponents/colors';


const Topbar = styled.div`
  height: 50px;
  padding: ${props => props.padding? props.padding:'15'}px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: solid 1px #D9D9D9;
`;

const Title = styled.div`
  font-size: 20px;
  font-weight: bold;
`

const MoreButton = styled.div`
  cursor: pointer;
  color: ${Colors.Dark5};
  font-size: 14px;
  i {
    width: 18px;
    height: 18px;
    text-align: center;
    color: #9b9b9b;
    border: solid #9b9b9b 1px;
    padding: 1px 1px 1px 2px;
    border-radius: 100%;
    margin-left: 10px;
  }
  a {
    color: #9b9b9b;
  }
`

export default props => {
  return (
    <Topbar padding={props.padding}>
      <Title>{props.title}{props.num ? `(${props.num})` : ''}</Title>
      <MoreButton>
        {
          props.bclass ? 
          <CupoySrefView
            statename={props.state || '/'}
            querys={{ bclass: props.bclass }}
          >
            更多
            <i className="zmdi zmdi-chevron-right"></i>
          </CupoySrefView>
          :
          <CupoySrefView
            statename={props.state || '/'}
          >
            更多
            <i className="zmdi zmdi-chevron-right"></i>
          </CupoySrefView>
        }
      </MoreButton>
    </Topbar>
  )
}
